import { Space, Typography } from "antd";
import { ContentWrapper } from "../../../../../Components/Layout/ContentWrapper";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { AddNewTemplateDocument } from "../../../../ContractManagement/Templates/Onboarding/AddNewTemplateDocument";

export const TemplateSelection = () => {
  const navigate = useNavigate();
  return (
    <>
      <ContentWrapper customTitle={
                <Space align="start">
                  <Icon
                    onClick={() => navigate(-1)}
                    icon="akar-icons:arrow-left"
                    style={{
                      fontSize: "1.8rem",
                      cursor: "pointer",
                    }}
                  />
                  <span>
                    <Typography.Title level={3} style={{ margin: 0 }}>
                      Template
                    </Typography.Title>
                  </span>
                </Space>
              }>
        <AddNewTemplateDocument/>
      </ContentWrapper>
    </>
  );
};
